






























import { Component, Vue, Inject, InjectReactive } from 'vue-property-decorator'

@Component({})
export default class OutdoorSettingButton extends Vue {
  @InjectReactive('outdoor-beacon-display')
  beaconDisplay!: boolean

  @InjectReactive('outdoor-beacon-animation')
  beaconAnimation!: boolean

  @InjectReactive({ from: 'outdoor-setting-floor-opacity', default: 0 })
  floorOpacity!: number

  @InjectReactive('outdoor-beacon-setting-loading')
  beaconSettingLoading!: boolean

  @Inject('outdoor-change-beacon-display')
  updateBeaconDisplay!: () => void

  @Inject('outdoor-update-beacon-animation')
  updateBeaconAnimation!: () => void

  @Inject('outdoor-update-floor-stranparent')
  editSlide!: () => void
}
